export default __webpack_public_path__ + "static/media/avasta.35f80079.woff";